export const IMPORTAR_DADOS_TABELA_FRETE_DISABLED =
  'Para importar uma nova planilha as informações inseridas deverão ser removidas. Remover as FAIXAS DE KM e as CAPACIDADES ou clique em LIMPAR INFORMAÇÕES.'

export const IMPORTAR_DADOS_TABELA_PEDAGIO_DISABLED = `Para importar uma nova planilha as informações inseridas deverão ser removidas. Remova as FAIXAS DE KM ou clique em LIMPAR INFORMAÇÕES.`
